$(document).ready(function ()
{
    // Checkout panel
    $('body').on('submit', '#CartDrawer-FormSummary, #cart', function (e) {
        e.preventDefault();
        console.log('Checkout submit triggered');
        $.ajax({
            type: 'GET',
            url: '/cart.js',
            cache: false,
            dataType: 'json',
            success: function(cart) {
                console.log('cart success');
                console.log(cart);
                var json = {
                    cart
                };
                // LP checkout
                $.ajax({
                    type: 'POST',
                    // production API
                    url: 'https://api.liquorpilot.com/v2/shopify/cart',
                    headers: {
                        'x-client-id': 'pKcuBLuRt5ZPnClT02Bz',
                    },
                    data: JSON.stringify(json),
                    contentType: "application/json; charset=utf-8",
                    dataType: 'json',
                    cache: false,
                    success: function(response) {
                        window.location.href = response.partner.ecommerce_website_url + '/c/' + response.checkout.token;
                    },
                    error: function(errMsg) {
                        console.error(errMsg);
                    }
                });
            }
        });
    });
});